import { render, staticRenderFns } from "./LcSummaryItem.vue?vue&type=template&id=1f51b0d0&scoped=true"
import script from "./LcSummaryItem.vue?vue&type=script&lang=js"
export * from "./LcSummaryItem.vue?vue&type=script&lang=js"
import style0 from "./LcSummaryItem.vue?vue&type=style&index=0&id=1f51b0d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f51b0d0",
  null
  
)

export default component.exports